import api from "./api";

// GET all properties
export const getAllServices = async () => {
    try {
        const response = await api.get("/api/service/all");
        return response.data;
    } catch (error) {
        throw error;
    }
};

// GET a property by ID
export const getServicesByCategory = async (category) => {
    try {
        const response = await api.get(`/api/service/category/${category}`);
        if (!response.data?.success) {
            // Return an error message instead of throwing
            return { success: false, message: response.data?.message || "No services found in this category" };
        }
        return { success: true, services: response.data?.services };
    } catch (error) {
        // Handle 404 or any other error here
        if (error.response?.status === 404) {
            return { success: false, message: "No services found for this category" };
        }

        return { success: false, message: error.message || "An unexpected error occurred while fetching services." };
    }
};

// POST (Create) a new property
export const createService = async (formData) => {
    try {
        const response = await api.post("/api/service", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};



export const applyForService = async (userId, serviceId) => {
    try {
        const response = await api.post("/api/service/apply", { userId, serviceId });
        return response.data;
    } catch (error) {
        return error?.response?.data;
    }
};




